import { FC, useMemo } from "react";
import DetailsSection from "../../../../../../components/Details/components/Main/Section/DetailsSection";
import QuotationCardList from "../../../components/QuotationCardList";
import Row from "../../../../../../components/Grid/Row";
import Column from "../../../../../../components/Grid/Column";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import {
  DocumentStages,
  DocumentStatus,
  Result,
  ResultStatus,
} from "../../../../../../graphql/__GENERATED__/types";
import Typography from "../../../../../../components/Typography";

const AvailableQuotations: FC = () => {
  const {
    orderedResults,
    setOrderedResults,
    handleDeleteResult,
    handleEditQuotationResult,
    documentData: { simulationResults, selectedResultIds, stage, status },
  } = useDocumentDetails();

  const { quotationPending, quotationDone } = useMemo(() => {
    const quotationPending =
      stage === DocumentStages.Simulation && status === DocumentStatus.Pending;
    const quotationDone =
      stage === DocumentStages.Simulation && status === DocumentStatus.Done;
    return { quotationPending, quotationDone };
  }, [stage, status]);

  const validResults =
    simulationResults?.filter(
      (result) => result && result.status !== ResultStatus.Error
    ) || [];

  const activeCards = useMemo(() => {
    return !quotationDone
      ? (selectedResultIds as string[])
      : orderedResults.map((result) => result && result._id).filter(Boolean);
  }, [orderedResults, quotationPending]);

  const handleSelectResult = (id: string) => {
    if (!quotationDone) {
      return;
    }
    if (activeCards.includes(id)) {
      // remove clicked card from ordered
      setOrderedResults(orderedResults.filter((result) => result._id !== id));
    } else if (activeCards.length < 3) {
      // Add clicked card to ordered
      const newAdded = validResults.filter(
        (result) => result && result._id === id
      );
      setOrderedResults([...orderedResults, ...newAdded] as Result[]);
    }
  };

  return (
    <DetailsSection title="Cotações disponíveis" subtitle>
      {validResults.length > 0 && (
        <>
          {!activeCards.length && !quotationPending && (
            <Row>
              <Column>
                <Typography
                  variant="textMedium"
                  component="p"
                  align="left"
                  uppercase
                >
                  Selecione até 3 cotações para enviar ao cliente:
                </Typography>
              </Column>
            </Row>
          )}
          <Row justify="start" align="center">
            <Column xs={12}>
              <QuotationCardList
                results={validResults as Result[]}
                activeCards={activeCards as string[]}
                allowEdition={quotationPending}
                editing={quotationDone}
                handleEdit={handleEditQuotationResult}
                handleDelete={(id) => handleDeleteResult(id)}
                onClick={handleSelectResult}
                showOrderNumbers
              />
            </Column>
          </Row>
        </>
      )}
    </DetailsSection>
  );
};

export default AvailableQuotations;
